export const TUI_DEFAULT_HTML5_MEDIA_ATTRIBUTES = [
    `id`,
    `class`,
    `src`,
    `style`,
    `controls`,
    `loop`,
    `muted`,
    `preload`,
    `autoplay`,
    `width`,
    `height`,
    `controlsList`,
];
